import Cookies from 'js-cookie';

//@ts-ignore
import CryptoJS from "crypto-js";
import {getToken, getTokenTmp, removeCsrfToken, removeToken, removeTokenTmp} from "../Storages/cookies";
import {authData} from "../Storages";

type HttpMethod = "GET" | "POST" | "PUT" | "DELETE" | "HEAD";

class Request {
    private url: string = '';
    private treatments: Array<(params: object) => object> = [];
    private treatmentsErrors: Array<(error: object) => object> = [];
    private headers: Array<{ [key: string]: string | (() => Promise<string> | string); }> = [];
    private countErrors = 0;

    private isLastPrepare = false;

    constructor(url: string) {
        this.setUrl(url);
        this.addMiddlewares();
        this.addHeader({
            'Accept': 'application/json',
            'Authorization': () => 'Bearer ' + getToken()
          });          

        if(process.env.REACT_APP_ENVIRONMENT !== 'local') {
            this.addHeader({'X-XSRF-TOKEN': async () => await getCsrfToken()});
        }

        this.clearAllowedErrors();
    }

    private addMiddlewares(reset: boolean = false) {

        if(reset) {
            this.clearPrepares();
        }

        this.prepare((params: object) => {
            const { data, response, method } = params as { data: any; response: any, method: HttpMethod };

            if(response.status === 401){
                removeToken();
                removeTokenTmp();
                removeCsrfToken();
                authData.remove();
                if(window.location.pathname !== '/login') {
                    window.location.href = '/login'; //solução temporária trocar isso assim que puder
                }
            }

            return params
        })
    }

    public get (path: object | string | undefined = undefined, params: object | string | undefined = undefined): Promise<any> {
        const {path: uri, params: obj} = Request.filterParams(path, params);

        const payload = {
            method: 'GET' as HttpMethod,
            path: uri as string | undefined,
            queryString: obj as object | undefined
        };

        return this.makeFetch(payload)
    }

    public post (path: object | string | undefined = undefined, params: object | string | undefined = undefined): Promise<any> {
        const {path: uri, params: obj} = Request.filterParams(path, params);

        const payload = {
            method: 'POST' as HttpMethod,
            path: uri as string | undefined,
            body: obj as object | undefined
        };

        return this.makeFetch(payload)
    }

    public put (path: object | string | undefined = undefined, params: object | string | undefined = undefined): Promise<any> {
        const {path: uri, params: obj} = Request.filterParams(path, params);

        const payload = {
            method: 'PUT' as HttpMethod,
            path: uri as string | undefined,
            body: obj as object | undefined
        };

        return this.makeFetch(payload)
    }

    public delete (path: object | string | undefined = undefined, params: object | string | undefined = undefined): Promise<any> {
        const {path: uri, params: obj} = Request.filterParams(path, params);

        const payload = {
            method: 'DELETE' as HttpMethod,
            path: uri as string | undefined,
            body: obj as object | undefined
        };

        return this.makeFetch(payload)
    }

    private static filterParams(path: object | string | undefined = undefined, params: object | string | undefined = undefined): {params?: object, path?: string} {
        if (typeof params === 'undefined' && typeof path === 'object') {
            params = path;
        }

        if (typeof path !== 'string') {
            path = undefined;
        }

        if (typeof params !== 'object') {
            params = undefined;
        }

        return {
            params: params as object | undefined,
            path: path as string | undefined
        }
    }

    public addErrorToCount (): void {
        this.countErrors++;
    }

    public getCountErrors (): number {
        return this.countErrors;
    }

    public clearAllowedErrors (): void {
        this.countErrors = 0;
    }

    private clearPrepares() {
        this.treatments = [];
        this.treatmentsErrors = [];
    }

    public prepare(callback: (params: object) => object): this {

        if(this.isLastPrepare) {
            this.treatments.pop();
            this.isLastPrepare = false;
        }

        this.treatments.push(callback);
        return this;
    }

    public prepareError(callback: (error: object) => object): this {
        this.treatmentsErrors.push(callback);
        return this;
    }

    public addHeader(header: { [key: string]: string | (() => Promise<string> | string) }): this {
        this.headers.push(header);
        return this;
    }

    public removeHeader(key?: string): this {
        if (key) {
            // this.headers = this.headers.filter(header => !header.hasOwnProperty(key));
            this.headers = this.headers.map(obj => {
                for (const k in obj) {
                    if (!obj.hasOwnProperty(k)) {
                        continue;
                    }

                    if(k === key) {
                        delete obj[key];
                    }
                }
                return obj;
            });
        }
        return this;
    }

    public removeAuthorizationHeader(): this {
        this.removeHeader('Authorization');
        return this;
    }

    public swapAuthorizationTempHeader(): this {
        this.removeAuthorizationHeader();
        this.addHeader({'Authorization': () => 'Bearer ' + <string>getTokenTmp()});
        return this;
    }

    private executeTreatments(params: object): object {

        if (!this.isLastPrepare) {
            this.prepare(async (params: object) => {
                const {data} = await params as { data: any }
            
                return data
            });
            this.isLastPrepare = true;
        }

        return this.treatments.reduce((current, treatment) => {
            if (current instanceof Promise) {
                return current.then(res => treatment(res));
            }
    
            const result = treatment(current);
    
            if (result instanceof Promise) {
                return result;
            }
    
            return result;
        }, params);
    }

    private executeTreatmentsError(error: object): object {
        return this.treatmentsErrors.reduce((currentParams, treatment) => {
            return treatment(currentParams);
        }, error);
    }

    private async makeFetch({
                          method,
                          body = {},
                          queryString = {},
                          path = ''
                      }: {
                          method: HttpMethod;
                          body?: object | undefined;
                          queryString?: object | undefined;
                          path?: string | undefined;
                      }
    ): Promise<any> {

        let queryStringResult: string | undefined = '';

        if (path) {
            queryStringResult = ( queryStringResult + '/' + path)
        }

        if (method === 'GET' && Object.keys((queryString ?? {})).length > 0) {
            queryStringResult = (queryStringResult + this.toQueryString(queryString));
        }

        const options = await this.getOptions({method, body})

        return new Promise(async (resolve, reject) => {
            fetch(this.getUrl() + queryStringResult, options)
                .then(async response => {
                    // const data = await response.json();
                    const text = await response.text(); // Pega o conteúdo da resposta como string
                    const data = text ? JSON.parse(text) : {};
                    // console.info({SUCCESS: data})
                    resolve(this.executeTreatments({data: data, response, method}));
                })
                .catch(error => {
                    // console.info({  ERROR: error})
                    reject(this.executeTreatmentsError(error));
                });
        });
    }

    private toQueryString(params: any): string {


        const searchParams = new URLSearchParams();

        Object.entries(params).forEach(([key, value]) => {
            if (value !== undefined && value !== '') { // precisa descomentar isso, mas primeiro precisa corrigir o backend
                searchParams.append(key, String(value));
            }
        });


        let result = searchParams.toString();

        if(result) {
            result = '?' + result;
        }

        return result;
    }

    private async getOptions({ method, body }: { method: HttpMethod; body?: object | number }): Promise<object> {
        let headers = await this.getHeaders();
    
        // NUNCA envia body em GET ou HEAD
        if (method === 'GET' || method === 'HEAD') {
            return {
                method,
                headers
            };
        }
    
        const isFormData = body instanceof FormData;
    
        if (isFormData) {
            // Remove Content-Type para deixar o browser setar corretamente
            headers = Object.fromEntries(
                Object.entries(headers).filter(([key]) => key.toLowerCase() !== 'content-type')
            );
    
            return {
                method,
                headers,
                body
            };
        }
    
        return {
            method,
            headers: {
                ...headers,
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(body)
        };
    }
     

    private async getHeaders(): Promise<object> {
        const result = this.headers.reduce((combined, current) => {
            return { ...combined, ...current };
        }, {});

        for (const key in result) {
            if (!result.hasOwnProperty(key)) {
                continue;
            }

            if(typeof result[key] === 'function') {
                const value = result[key] as (() => string | Promise<string>);
                let finalValue = await value();

                if (finalValue) {
                    result[key] = finalValue;
                } else {
                    delete result[key];
                }
            }
        }

        return result;
    }

    private setUrl(url: string) {
        if(!url) {
            throw new Error('Parâmetro url não pode ser vazio');
        }

        this.url = url;
    }

    private getUrl() {
        if(!this.url) {
            throw new Error('Parâmetro url não foi previamente definido');
        }

        const api = process.env.REACT_APP_API_URL;

        if(!api) {
            throw new Error('O valor de REACT_APP_API_URL não foi definido');
        }

        return api + this.url;
    }
}

const makeRequest = (url: string): Request => {
    return new Request(url);
}

const generateCsrfToken = async (): Promise<void> => {
    if (process.env.REACT_APP_ENVIRONMENT === 'local') {
        return new Promise((resolve, reject) => resolve());
    }

    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}sanctum/csrf-cookie`, {
            method: 'GET',
            credentials: 'include'
        });

        if (!response.ok) {
            throw new Error('Falha ao obter o CSRF token.');
        }
    } catch (error) {
        console.error('Erro ao gerar CSRF token:', error);
    }
};

const getCsrfToken = async (): Promise<string> => {
    if (!Cookies.get('XSRF-TOKEN')) {
        await generateCsrfToken();
    }

    return Cookies.get('XSRF-TOKEN') || '';
};

export type {HttpMethod}

export {
    Request,
    generateCsrfToken
}

export default makeRequest;